import { BaseAPI } from '../../BaseApi';
import { UUID } from '../../../types/shared/UUID';
import { cleanupRequestWithNulls } from '../../cleanupRequests';
import { IOrderAttributesData } from '../../../types/order/attributes/IOrderAttributesData';
import { eAPITags } from '../../eAPITags';

export const AttributesApi = BaseAPI.injectEndpoints({
  endpoints: (build) => ({
    getAttributes: build.query<IOrderAttributesData, UUID>({
      query: (orderId) => `/timber/api/internal/orders/${orderId}/attributes`,
      providesTags: (result, error, orderId) => [{ id: orderId, type: eAPITags.OrderAttributes }],
    }),
    patchAttributes: build.mutation<void, { orderId: UUID; body: IOrderAttributesData }>({
      query: (request) => ({
        url: `/timber/api/internal/orders/${request.orderId}/attributes`,
        method: 'PATCH',
        body: cleanupRequestWithNulls(request.body),
      }),
      invalidatesTags: (result, error, { orderId }) => [{ type: eAPITags.OrderAttributes, id: orderId }],
    }),
  }),
});

export const { useGetAttributesQuery, usePatchAttributesMutation } = AttributesApi;
